import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';

export class ProviderSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    name: string;
    description: string;
    logoPublicUrl: string;
    accountId: number;
    businessCode: string;
}
